"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const BG_IMAGE = "https://getgeek-website-assets.b-cdn.net/AtlasDoesBG.webp";

const WhatAtlasDoesSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  // mobile/tablet: left (LTR) or right (Arabic), desktop: centered
  const textAlign = { xs: isArabic ? "right" : "left", md: "center" };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 2, sm: 3, md: 7 },
        backgroundColor: "#FFFFFF", // image load hone tak fallback
        backgroundImage: `url(${BG_IMAGE})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "26px", sm: "30px", md: "34px", lg: "38px" },
              fontWeight: 700,
              lineHeight: 1.25,
              color: "#14122B",
              fontFamily: "var(--font-plusjakarta)",
              mb: { xs: 2, sm: 2.5 },
            }}
          >
            {t("whatAtlasDoes.heading")}
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "14px", sm: "15px", md: "16px" },
              color: "#55556E",
              lineHeight: 1.8,
              fontWeight: 400,
              fontFamily: "var(--font-outfit)",
              maxWidth: 780,
              mx: { xs: 0, md: "auto" },
            }}
          >
            {t("whatAtlasDoes.description")}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default WhatAtlasDoesSection;